import React, { useEffect, useState, createRef } from 'react';
import moment from 'moment';
import { ListView } from '@tencent/ptp-fe-common';
import { filter } from 'lodash';
import { LeadsDataFilterShortcut as dateShortcuts } from '../../../consts/Common';
import { leadsTypeTreeForTableFilter } from '../../../consts/leadsTypeTree';
import { Tags } from '../../../consts/Tags';
import useCustomColumn from '../../hooks/useCustomFilter';
import { leadsCommonFuncAndConfig } from '../../pages/leadsmanage/leadsCommonFuncAndConfig';
import { withEmployeeList } from '../../../cacheAPIData/withEmployeeList';
import { withTagList } from '../../../cacheAPIData/withTagList';
import { RPCFactory } from '../../../utils/RequestUtil';

const Filter = (props) => {
  const lvObj = createRef();
  const payloads = () => ({});
  const customFunctions = () => ({});

  const [leadsOwner, setLeadsOwner] = useState([]);
  const [groupList, setGroupList] = useState([]);
  // 线索来源
  const leadsSourceIds = [];
  Object.keys(Tags.leadsSourceTag).forEach((key) => {
    leadsSourceIds.push({ value: key, label: Tags.leadsSourceTag[key] });
  });
  const getList = (params) =>
    new Promise((res, rej) => {
    });
  useEffect(() => {
    RPCFactory.employeeManage
    .getSimpleGroupList()
    .done((data) => {
      // setGroupList(data.list);
      const newGroups = [];
      for (let i = 0; i < data.list.length; i++) {
        newGroups.push({
          value: data.list[i].userGroupId,
          label: data.list[i].userGroupName,
        });
      }
      setGroupList(newGroups);
    })
    .fail((ret, msg) => {
      window.alert(`获取团队列表错误：${msg}`);
    });
  }, []);
  useEffect(() => {
    if (props.employeeList) {
      const newOwners = [];
      props.employeeList.forEach((employee) => {
        // var mark = employee.status == EmployeeFrozenStatus.NORMAL ? "有效" : "封停";
        let active = true;
        if (employee.status !== 0) active = false;
        if (employee.leadsReceiveStatus === 0) active = false;
        newOwners.push({
          active,
          value: employee.userId,
          label: `${employee.name} - ${employee.userGroupName}`,
        });
        setLeadsOwner(newOwners);
      });
    }
  }, [props.employeeList]);

  const tagGroups = filter(props.tagList, 'tagCount');
  const tags = tagGroups.map((tagGroupItem) => {
    return {
      value: tagGroupItem.tagGroupId,
      desc: tagGroupItem.tagGroupName,
      options: tagGroupItem.tagList.map((tagItem) => {
        return {
          value: tagItem.tagId,
          desc: tagItem.tagName,
        };
      }),
    };
  });
  const filterControls = [
    {
      name: 'startActionDate',
      title: '线索创建时间',
      type: 'date-picker',
      clearable: false,
      config: {
        type: 'range',
        longestRange: '365',
        useShortcut: true,
        shortcuts: dateShortcuts,
        optionalStartDate: '2021-01-01',
      },
    },
    {
      name: 'ownerIds',
      title: '归属人',
      type: 'select',
      config: {
        multiple: true,
        data: leadsOwner,
      },
    },
    {
      name: 'groupIds',
      title: '归属团队',
      type: 'select',
      config: {
        multiple: true,
        data: groupList,
      },
    },
    {
      name: 'leadsTags',
      title: '线索标签',
      type: 'select-tree',
      config: {
        multiple: true,
        data: tags,
        showParentNodeLabel: false,
        valueType: 'child',
      },
    },
    {
      name: 'actionSubTypes',
      title: '线索类型',
      type: 'select-tree',
      config: {
        multiple: true,
        data: leadsTypeTreeForTableFilter,
      },
    },
    {
      name: 'leadsSources',
      title: '线索来源',
      type: 'select',
      config: {
        multiple: true,
        data: leadsSourceIds,
      },
    },
  ];

  const defaultFilterKeys = ['startActionDate', 'ownerIds', 'groupIds'];
  const customFilterConfigure = useCustomColumn({
    defaultFilterKeys,
    controls: filterControls,
    storageKey: 'ams:user_profile:advertiser_custom_filters_/adhome/advertiser/account',
  });

  const initQuery = {
    startActionDate: {
      start_time: moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
  };
  const options = () => ({
    fetchConfig: {
      action: getList,
      $onRequest: (params) => {
        // 在这处理请求参数对象
        const obj = { ...params };
        delete obj.startActionDate;
        delete obj.page_size;
        delete obj.page;
        if (params.startActionDate) {
          obj.startCreateTime = `${params.startActionDate.start_time} 00:00:00`;
          obj.endCreateTime = `${params.startActionDate.end_time} 23:59:59`;
        }
        obj.timeUnit = 'DAYS';
        props.setQueryParams(obj);
        return obj;
      },
      $onResponse(data) {
        try {
          data.list.forEach((obj) => {
            obj.customizedAttributes.forEach((item) => {
              obj[item.name] = item.value;
            });
          });
        } catch (error) {
          console.error(error);
        }
        return data;
      },
      $onError: window.alert,
    },
    filterConfig: {
      resetable: false,
      controls: filterControls,
      customConfigure: customFilterConfigure,
      defaultValuesByKey: initQuery,
    },
    tableConfig: {
      defaultPageSize: 10,
      select: null,
      onColumnWidthChange: leadsCommonFuncAndConfig.handleColumnWidthChange,
      optionalConfig: {
        type: 'optional',
        target: 'leadsId',
        multiple: true,
        canOptional: true,
        onOptionalChange: () => {},
      },
      columns: ['name', 'tel', 'leadsFollowTagName'],
    },
  });
  return (
    <div className="filter-part">
      <div className="card" style={{ paddingTop: 0 }}>
        <div className="datalist">
          <ListView
            className="lv"
            ref={lvObj}
            options={options}
            payloads={payloads}
            customFunctions={customFunctions}
          />
        </div>
      </div>
    </div>
  );
};

export const FilterPart = withTagList(withEmployeeList(Filter));
